<template>
    <div class="error">
        <panel-ms>
            <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M45.75 50.6667V26.0833M45.75 65.4167V63.25M90 45.75C90 51.561 88.8554 57.3151 86.6317 62.6837C84.4079 68.0524 81.1485 72.9305 77.0395 77.0395C72.9305 81.1485 68.0524 84.4079 62.6837 86.6317C57.3151 88.8554 51.561 90 45.75 90C39.939 90 34.1849 88.8554 28.8163 86.6317C23.4476 84.4079 18.5695 81.1485 14.4605 77.0395C10.3515 72.9305 7.0921 68.0524 4.86833 62.6837C2.64456 57.3151 1.5 51.561 1.5 45.75C1.5 34.0142 6.16204 22.759 14.4605 14.4605C22.759 6.16204 34.0142 1.5 45.75 1.5C57.4858 1.5 68.741 6.16204 77.0395 14.4605C85.338 22.759 90 34.0142 90 45.75Z"  stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h3>К сожалению, ничего не найдено</h3>
            <p>Попробуйте изменить поисковой запрос</p>
        </panel-ms>
    </div>
</template>
<script>
import panelMs from './common/panelMs.vue';
export default{
    components:{
        panelMs
    },

}
</script>

<style>
.error{
    margin: auto;
    margin-top: 240px;
    margin-bottom: 40px;
    width: 1350px;

}
.error .panel {
    text-align: center;
    width: 100%;
    padding:76px 32px ;
}
.error svg{
    stroke:#007BB8;
    margin-bottom: 32px;
}
@media (max-width: 1000px){  
    .error {
        width: calc(100% - 40px);
        margin-left:20px;
        margin-right:20px;
    }
}
</style>